import { useMutation } from '@tanstack/react-query';
import { legacy } from '@/shared/api/client';
import { isMultiStoreLeads } from '@/shared/lib/passbook-utils';
import { normalizeLeadUniqueIdField } from '@/shared/lib/unique-id-lookup';
import type { Lead, PaginatedResponse, Passbook } from '@/shared/types';

const OPERATOR_SEARCH_COLUMNS = [
  { data: 'updated' },
  { data: 'createdAt' },
  { data: 'profile.name' },
  { data: 'profile.uniqueId' },
  { data: 'total_points' },
  { data: 'email' },
  { data: 'birthday' },
  { data: 'phone' },
];

function normalizeOperatorSearchQuery(raw: string): string {
  const trimmed = raw.trim();
  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 11) return digits;
  return trimmed;
}

function headers(idPassbook: string) {
  return { headers: { 'X-Passbook-Id': idPassbook } };
}

/**
 * Busca de cliente no Operador.
 * Usa `/usersPaginate` — o `/users` legado só filtra por uniqueId.
 */
export function useOperatorSearch(idPassbook: string, passbook: Passbook) {
  const multi = isMultiStoreLeads(passbook);
  const endpoint = multi ? '/usersPaginateMulti' : '/usersPaginate';

  return useMutation({
    mutationFn: async (query: string) => {
      const searchValue = normalizeOperatorSearchQuery(query);
      const res = await legacy.post<PaginatedResponse<Lead>>(
        endpoint,
        {
          id_passbook: idPassbook,
          role: ['Member', 'Employee'],
          length: 20,
          skip: 0,
          search: { value: searchValue },
          order: [{ column: 0, dir: 'desc' }],
          columns: OPERATOR_SEARCH_COLUMNS,
          ...(multi ? { multiStore: true } : {}),
        },
        headers(idPassbook),
      );
      const rows = Array.isArray(res?.data) ? res.data : [];
      return rows.map(normalizeLeadUniqueIdField);
    },
  });
}
